import hydrate from '../common/hydrate';
import CookieBanner from './components/CookieBanner';
import { root, name } from './manifest.json';
hydrate(CookieBanner, root, name);
if (module.hot) {
    module.hot.accept();
}
